import { configureStore } from '@reduxjs/toolkit';

import adminDrugClasses from './features/adminDrugClasses/slice';
import adminGlobalMessages from './features/adminGlobalMessages/slice';
import adminImportMedications from './features/adminImportMedications/slice';
import adminInquiries from './features/adminInquiries';
import adminOrganizations from './features/adminOrganizations/slice';
import adminProgramCodes from './features/adminProgramCodes/slice';
import adminRiskLevels from './features/adminRiskLevels/slice';
import adminSupplementInquiryStatuses from './features/adminSupplementInquiryStatuses/slice';
import athleteGenders from './features/athleteGenders/slice';
import athleteRoleGroups from './features/athleteRoleGroups/slice';
import athleteRoles from './features/athleteRoles/slice';
import athleteSports from './features/athleteSports/slice';
import auth from './features/auth';
import dashboardOrgInfo from './features/dashboardOrgInfo/slice';
import drugClasses from './features/drugClasses/slice';
import fileUploadState from './features/fileUploadState/slice';
import highRiskSupplementDetails from './features/highRiskSupplementDetails/slice';
import highRiskSupplements from './features/highRiskSupplements/slice';
import highRiskSupplementsSearch from './features/highRiskSupplementsSearch/slice';
import inquiries from './features/inquiries';
import inquiryDraft from './features/inquiryDraft';
import inquiryResponse from './features/inquiryResponse/slice';
import inquiryStatuses from './features/inquiryStatuses/slice';
import loading from './features/loading/slice';
import medications from './features/medications';
import medicationSettings from './features/medicationSettings/slice';
import notifications from './features/notifications/slice';
import organizations from './features/organizations/slice';
import programCodes from './features/programCodes/slice';
import resources from './features/recources/slice';
import riskLevelDescriptions from './features/riskLevelDescriptions/slice';
import riskLevels from './features/riskLevels/slice';
import riskSupplementCategories from './features/riskSupplementsCategories/slice';
import supplementCategories from './features/supplementCategories/slice';
import supplementResponseStatuses from './features/supplementResponseStatuses/slice';
import supplementSettings from './features/supplementSettings/slice';
import warningTypes from './features/warningTypes/slice';

const store = configureStore({
  reducer: {
    adminDrugClasses,
    adminGlobalMessages,
    adminImportMedications,
    adminInquiries,
    adminOrganizations,
    adminProgramCodes,
    adminRiskLevels,
    adminSupplementInquiryStatuses,
    athleteGenders,
    athleteRoleGroups,
    athleteRoles,
    athleteSports,
    auth,
    dashboardOrgInfo,
    drugClasses,
    inquiries,
    inquiryDraft,
    inquiryResponse,
    inquiryStatuses,
    loading,
    medications,
    medicationSettings,
    notifications,
    organizations,
    programCodes,
    riskLevelDescriptions,
    riskLevels,
    resources,
    supplementCategories,
    supplementResponseStatuses,
    highRiskSupplements,
    warningTypes,
    riskSupplementCategories,
    highRiskSupplementDetails,
    highRiskSupplementsSearch,
    supplementSettings,
    fileUploadState,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          'addSupplementToInquiry/fulfilled',
          'adminActivateOrganization/fulfilled',
          'adminCreateNewOrganization/fulfilled',
          'adminCreateNewProgramCode/fulfilled',
          'adminCreateNewSupplement/fulfilled',
          'adminDeactivateOrganization/fulfilled',
          'adminDeactivateSupplement/fulfilled',
          'adminDeleteGlobalMessage/fulfilled',
          'adminEditOrganization/fulfilled',
          'adminEditProgramCode/fulfilled',
          'adminImportMedications/fulfilled',
          'adminImportMedications/pending',
          'adminImportSynonymsList/fulfilled',
          'adminImportSynonymsList/pending',
          'adminSearchIngredients/fulfilled',
          'adminSearchOrganizations/fulfilled',
          'adminSearchSupplements/fulfilled',
          'adminSetGlobalMessage/fulfilled',
          'adminSupplementMarkAsMedication/fulfilled',
          'adminSupplementMatchExisting/fulfilled',
          'adminSupplementNeedsMoreInfo/fulfilled',
          'adminSupplementSendInquiry/fulfilled',
          'createInquiry/fulfilled',
          'createNewSupplement/fulfilled',
          'deleteInquiryDraft/fulfilled',
          'editUserEnteredSupplement/fulfilled',
          'getAdminDrugClasses/fulfilled',
          'getAdminGlobalMessage/fulfilled',
          'getAdminInquiryList/fulfilled',
          'getAdminMatchingSupplement/fulfilled',
          'getAdminOrganizationDetails/fulfilled',
          'getAdminProgramCodeDetails/fulfilled',
          'getAdminProgramCodes/fulfilled',
          'getAdminRiskLevels/fulfilled',
          'getAdminSupplementDetails/fulfilled',
          'getAdminSupplementInquiryStatuses/fulfilled',
          'getAdminSupplementResponse/fulfilled',
          'getAthleteGenders/fulfilled',
          'getAthleteRoleGroups/fulfilled',
          'getAthleteRoles/fulfilled',
          'getAthleteSports/fulfilled',
          'getCannedResponseCategories/fulfilled',
          'getDashboardOrgInfo/fulfilled',
          'getDrugClasses/fulfilled',
          'getInquiryDetails/fulfilled',
          'getInquiryList/fulfilled',
          'getInquiryResponse/fulfilled',
          'getInquiryStatuses/fulfilled',
          'getMedicationDetails/fulfilled',
          'getMedicationSettings/fulfilled',
          'getOrganizations/fulfilled',
          'getPrintInquiryResponse/fulfilled',
          'getProgramCodes/fulfilled',
          'getRiskLevelDescriptions/fulfilled',
          'getRiskLevels/fulfilled',
          'getSharedInquiryResponse/fulfilled',
          'getSupplementCategories/fulfilled',
          'getSupplementDetails/fulfilled',
          'getSupplementResponseDetails/fulfilled',
          'getSupplementResponseStatuses/fulfilled',
          'getUserEnteredSupplement/fulfilled',
          'getUserEnteredSupplementDetails/fulfilled',
          'getUserProfile/fulfilled',
          'login/fulfilled',
          'markSupplementResponseAsViewed/fulfilled',
          'refreshToken/fulfilled',
          'removeSupplementFromInquiryDraft/fulfilled',
          'searchSupplements/fulfilled',
          'shareInquiryResponse/fulfilled',
          'submitInquiry/fulfilled',
          'submitSupplementNeedsInfoForm/fulfilled',
        ],
      },
    }),
});

export default store;
